import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from "../../..";

var CalendarWeekday = function CalendarWeekday(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    width: 1 / 7
  }, rest), /*#__PURE__*/React.createElement(Text, null, children));
};

CalendarWeekday.propTypes = {
  children: PropTypes.node.isRequired
};
export default CalendarWeekday;